<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->
      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>
      <div :class="isSideBar == true ? 'mb-6' : 'vx-row mb-6'">
        <div
          v-if="isSideBar"
          :class="
            isSideBar == true ? 'vx-col w-full mb-3' : 'vx-col sm:w-1/3 w-full'
          "
        >
          <span><b>Status: </b></span>
          <span>{{ this.dados.deletedAt ? 'Inativo' : 'Ativo' }}</span>
        </div>

        <div
          :class="
            isSideBar == true ? 'vx-col w-full mb-3' : 'vx-col sm:w-1/3 w-full'
          "
        >
          <span>Tipo de Veículo</span>
          <v-select
            :options="tipoFipe"
            name="Tipo"
            id="Tipo"
            v-model="tipoVeiculo"
            v-validate="{ required: true }"
            :state="validateState('Tipo')"
            :class="validateClass('Tipo')"
            :disabled="isSideBar ? true : false"
          ></v-select>
        </div>

        <div
          :class="
            isSideBar == true ? 'vx-col w-full mb-3' : 'vx-col sm:w-1/3 w-full'
          "
        >
          <span>Grupo</span>
          <v-select
            :options="grupos"
            name="Grupo"
            id="Grupo"
            v-model="grupo"
            v-validate="{ required: true }"
            :state="validateState('Grupo')"
            :class="validateClass('Grupo')"
            :disabled="isSideBar ? true : false"
          ></v-select>
        </div>

        <div
          :class="
            isSideBar == true ? 'vx-col w-full mb-3' : 'vx-col sm:w-1/3 w-full'
          "
        >
          <span>Marca</span>
          <v-select
            :options="marcas"
            name="Marca"
            id="Marca"
            v-model="marca"
            v-validate="{ required: true }"
            :state="validateState('Marca')"
            :class="validateClass('Marca')"
            :disabled="isSideBar ? true : false"
          ></v-select>
        </div>

        <div
          v-if="tipoCadastro == 'Modelo'"
          :class="
            isSideBar == true ? 'vx-col w-full mb-3' : 'vx-col sm:w-1/3 w-full'
          "
        >
          <span>Modelo</span>
          <v-select
            :options="modelos"
            name="Modelo"
            id="Modelo"
            v-model="modelo"
            v-validate="{ required: true }"
            :state="validateState('Modelo')"
            :class="validateClass('Modelo')"
            :multiple="!isSideBar ? true : false"
            :close-on-select="isSideBar ? true : false"
            :disabled="isSideBar ? true : false"
          ></v-select>
        </div>

        <div
          :class="
            isSideBar == true
              ? 'vx-col w-full mb-3'
              : 'vx-col sm:w-1/3 w-full  mt-2'
          "
        >
          <span>Estado</span>
          <v-select
            :options="estados"
            label="label"
            name="Estado"
            id="Estado"
            @input="
              buscaDadosSelectsCidades(
                'domMunicipio',
                'cidades',
                'nomeCidade',
                'idCidade',
              ),
                selecionaEstado()
            "
            :disabled="isSideBar ? true : false"
            v-model="estado"
          ></v-select>
        </div>

        <div
          :class="
            isSideBar == true
              ? 'vx-col w-full mb-3'
              : 'vx-col sm:w-1/3 w-full mt-2'
          "
        >
          <span>Cidade</span>
          <v-select
            :options="cidades"
            label="label"
            name="Cidade"
            id="Cidade"
            v-model="cidade"
            :disabled="isSideBar ? true : false"
          ></v-select>
        </div>

        <div
          :class="
            isSideBar == true
              ? 'vx-col w-full mb-3 '
              : 'vx-col sm:w-1/3 w-full  mt-2'
          "
        >
          <span>Valor da Cota</span>
          <vs-number
            style="padding: 10px"
            class="w-full vs-inputx vs-input--input medium"
            name="Valor da Cota"
            id="valorCota"
            v-model="formCadastro.valorCota"
            v-validate="{ required: true }"
            :state="validateState('valorCota')"
            :danger="validateClass('valorCota')"
            v-bind="percentage"
          ></vs-number>
        </div>

        <div
          :class="
            isSideBar == true
              ? 'vx-col w-full mb-3'
              : 'vx-col sm:w-1/3 w-full   mt-2'
          "
        >
          <span>Valor da Participação</span>
          <vs-number
            style="padding: 10px"
            class="w-full vs-inputx vs-input--input medium"
            name="Valor da Participação"
            id="valorParticipacao"
            v-model="formCadastro.valorParticipacao"
            v-validate="{ required: true }"
            :state="validateState('valorParticipacao')"
            :danger="validateClass('valorParticipacao')"
            v-bind="money"
          ></vs-number>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button color="success" class="mr-3 mb-2" v-if="isSideBar == true"
            >Editar</vs-button
          >
          <vs-button
            color="warning"
            @click="resetForm"
            class="mr-3 mb-2"
            v-if="isSideBar == false"
            >Limpar</vs-button
          >
          <vs-button color="success" class="mr-3 mb-2" v-if="isSideBar == false"
            >Adicionar</vs-button
          >
        </div>
      </div>
    </form>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from '../../locale';
import * as lang from 'vuejs-datepicker/src/locale';
import vSelect from 'vue-select';
import service from '../../services';
import { Money } from 'v-money';

export default {
  props: [
    'tipo',
    'entidade',
    'pk',
    'tipoCadastro',
    'idGrupo',
    'isSideBar',
    'dados',
  ],
  watch: {
    tipoVeiculo(value) {
      this.form.codigoTipoVeiculo = value.id;
      // this.marca = null;
      // this.marcas = []
      this.buscaDadosMarcas();
      this.buscaDadosGrupos();
    },
    marca(value) {
      this.form.codigoMarca = value.id;
      // this.modelo = null;
      // this.modelos = [];
      if (this.tipoCadastro == 'Modelo') this.buscaDadosModelos();
      // this.buscaDadosGruposPorMarcaModelo();
    },
    modelo(value) {
      this.form.codigoModelo = value.id;
      // this.buscaDadosGruposPorMarcaModelo()
      // if (!Array.isArray(this.modelo) == false) this.modelo = Array(this.modelo)

      // if (Array.isArray(this.modelo)) {
      // } else {
      //   this.modelo = Array(this.modelo)
      // }
      // if (typeof this.modelo.id != 'string') this.modelo.id = String(this.modelo.id)
    },
    cidade(newValue) {
      if (newValue) {
        this.formCadastro.cidade = newValue.label;
      }

      if (!newValue) {
        this.formCadastro.cidade = '';
        this.cidade = '';
      }
    },
    estado(value) {
      if (value) {
        this.formCadastro.estado = value.label;
      }

      if (!value) {
        this.formCadastro.estado = '';
        this.estado = '';

        this.cidades = [];
        this.cidade = '';
        this.formCadastro.cidade = '';
      }
    },
    // eslint-disable-next-line no-unused-vars
    dados(value) {
      this.preencheForm();
    },
  },
  data() {
    return {
      percentage: {
        decimal: '.',
        thousands: '',
        prefix: '',
        suffix: ' %',
        precision: 1,
        maxLength: 6,
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: true,
      },
      aguardeCadastro: false,
      idEmpresa: null,
      grupos: [],
      marcas: [],
      modelos: [],
      tipoFipe: [],
      languages: lang,
      funcoesValicao: null,
      tipoVeiculo: null,
      marca: null,
      estados: [],
      cidades: [],
      estado: null,
      cidade: null,
      tipoVeiculoAux: null,
      marcaAux: null,
      grupoAux: null,
      modelo: null,
      grupo: null,
      form: {
        codigoTabelaReferencia: null,
        codigoTipoVeiculo: null,
        codigoMarca: null,
        codigoModelo: null,
      },
      formCadastro: {
        idEmpresa: null,
        tipo: null,
        idTipo: null,
        grupo: null,
        idGrupo: null,
        marca: null,
        idMarca: null,
        modelo: null,
        idModelo: null,
        valorCota: null,
        valorParticipacao: null,
        estado: '',
        cidade: '',
      },
    };
  },
  methods: {
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },

    preencheForm() {
      if (this.dados.idCotaParticipacao) {
        this.formCadastro.idCotaParticipacao = this.dados.idCotaParticipacao;
        (this.formCadastro.idEmpresa = this.dados.idEmpresa),
          (this.tipoVeiculo = {
            id: this.dados.idTipo,
            label: this.dados.tipo,
          });
        this.tipoVeiculoAux = {
          ...this.tipoVeiculo,
        };
        this.marca = {
          id: this.dados.idMarca.toString(),
          label: this.dados.marca,
        };

        if (this.dados.estado) {
          this.estado = this.dados.estado;
        }
        if (this.dados.cidade) {
          this.cidade = this.dados.cidade;
        }

        if (this.dados.cidade == null) {
          this.cidade = '';
        }

        if (this.dados.estado == null) {
          this.estado = '';
        }

        this.marcaAux = {
          ...this.marca,
        };
        (this.modelo = [
          {
            id: this.dados.idModelo,
            label: this.dados.modelo,
          },
        ]),
          (this.grupo = {
            id: this.dados.idGrupo,
            label: this.dados.grupo,
          });
        this.grupoAux = {
          ...this.grupo,
        };
        this.formCadastro.valorCota = this.dados.valorCota;
        this.formCadastro.valorParticipacao = this.dados.valorParticipacao;
      } else {
        this.resetForm();
      }
    },
    buscaDadosSelectsCidades(model, array, campoDescricao, campoPK) {
      if (!this.estado) {
        return;
      }

      this.$vs.loading();
      this[array] = [];

      service
        .getAll('g', {}, `${model}/list/codUf/${this.estado.id}`)
        .then((res) => {
          res.data.forEach((element) => {
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
          });

          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
    selecionaEstado() {
      if (!this.estado) return;

      var aux = this.estados.find((x) => x.id == this.estado.id);
      this.form.estado = aux.label;
    },
    resetForm() {
      (this.tipoVeiculo = null),
        (this.grupo = null),
        (this.marca = null),
        (this.modelo = null),
        (this.estado = ''),
        (this.cidade = ''),
        (this.formCadastro = {
          idTipo: null,
          tipo: null,
          grupo: null,
          idGrupo: null,
          marca: null,
          idMarca: null,
          modelo: null,
          idModelo: null,
          modelosSelecionados: [],
          valorCota: 0.0,
          valorParticipacao: '0.0%',
          estado: '',
          cidade: '',
        });
    },

    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });
      });
    },
    buscaDadosGrupos() {
      service
        .getAll('Grupo', {}, 'list/idEmpresa=' + this.idEmpresa)
        .then((res) => {
          this.grupos = [];
          res.data.forEach((element) => {
            if (element.idTipoFipe == this.tipoVeiculo.id)
              this.grupos.push({
                id: element.idGrupo,
                label: element.nomeGrupo,
              });
          });
        });
    },
    // buscaDadosGruposPorMarcaModelo() {
    //   const objBuscaGrupo = {
    //     idEmpresa: this.idEmpresa,
    //     idMarca: Number(this.marca.id),
    //     idModelo: this.modelo ? this.modelo.id : null,
    //     tipo: this.tipoVeiculo.id
    //   }

    //   service.post("CotacaoAberta", "buscaGrupoMarcaModelo", objBuscaGrupo)
    //   .then((res) => {
    //       res.data.forEach((element) => {
    //         this.grupo = this.isSideBar ? this.grupoAux.id != this.grupo.id ? null: this.grupo : null
    //         this.grupos = []
    //         this.grupos.push({
    //           id: element.id,
    //           label: element.label,
    //         });
    //       });
    //     })
    // },
    buscaTiposFipe() {
      service.getAll('g', {}, `domTipoFipe/list/`).then((res) => {
        res.data.forEach((element) => {
          this.tipoFipe.push({
            id: element.idTipoFipe,
            label: element.nomeTipo,
          });
        });
      });
    },
    // buscaUltimaTabelaFipe() {
    //   this.$vs.loading();
    //   service.post("Fipe", `ConsultarTabelaDeReferencia`, {}).then((res) => {
    //     this.form.codigoTabelaReferencia = res.data[0].Codigo;
    //     this.$vs.loading.close();
    //   });
    // },
    buscaDadosMarcas() {
      this.$vs.loading();
      service.post('Fipe', `ConsultarMarcas`, this.form).then((res) => {
        var arr = res.data;
        this.marca = this.isSideBar
          ? this.tipoVeiculoAux.id != this.tipoVeiculo.id
            ? null
            : this.marca
          : null;
        this.marcas = [];
        arr.forEach((element) => {
          this.marcas.push({
            id: element.id,
            label: element.name,
          });
        });
        this.$vs.loading.close();
        this.$forceUpdate();
      });
    },
    buscaDadosModelos() {
      this.$vs.loading();
      service.post('Fipe', `ConsultarModelos`, this.form).then((res) => {
        this.modelo = this.isSideBar
          ? this.marcaAux.id != this.marca.id
            ? null
            : this.modelo
          : null;
        this.modelos = [];
        const arr = res.data[0];
        arr.forEach((element) => {
          this.modelos.push({
            id: element.id,
            label: element.name,
          });
        });
        this.$vs.loading.close();
      });
    },

    onSubmit() {
      this.$vs.loading();
      this.formCadastro.idEmpresa = this.idEmpresa;
      this.formCadastro.valorCota = Number(this.formCadastro.valorCota);

      // if (this.estado) {
      //   this.formCadastro.estado = this.estado.label;
      // }

      // if (this.cidade) {
      //   this.formCadastro.cidade = this.cidade.label;
      // }

      var action = 'Atualizar';
      // eslint-disable-next-line no-unused-vars
      var msgRetorno = 'Registro atualizado com sucesso';
      if (!this.formCadastro.idCotaParticipacao) {
        action = 'Adicionar';
        msgRetorno = 'Cota de Particiapação adicionada com sucesso';
      }

      if (this.grupo) {
        this.formCadastro.grupo = this.grupo.label;
        this.formCadastro.idGrupo = this.grupo.id;
      }

      if (this.marca) {
        this.formCadastro.marca = this.marca.label;
        this.formCadastro.idMarca = this.marca.id;
      }

      if (this.modelo) {
        this.formCadastro.modelosSelecionados = [];

        //Para o caso de atualizar somente um item
        this.formCadastro.modelo = this.modelo[0].label;
        this.formCadastro.idModelo = this.modelo[0].id;

        //Para adicionar um ou mais itens, e atualizar vários itens
        this.modelo.forEach((element) => {
          this.formCadastro.modelosSelecionados.push({
            idModelo: element.id,
            modelo: element.label,
          });
        });
      }
      if (this.tipoVeiculo) {
        this.formCadastro.tipo = this.tipoVeiculo.label;
        this.formCadastro.idTipo = this.tipoVeiculo.id;
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          service
            .post(this.entidade, action, this.formCadastro)
            .then(() => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: `Operação Realizada com sucesso`,
                color: 'success',
              });
              this.$emit('concluido');
              this.$vs.loading.close();
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: error,
                color: 'danger',
              });
              this.$vs.loading.close();
            });
        } else {
          this.$vs.loading.close();
        }
      });
    },
  },
  mounted() {
    // this.buscaDadosGrupos();
    this.buscaTiposFipe();
    // this.buscaUltimaTabelaFipe();
    this.buscaDadosSelects('domUf', 'estados', 'nomeUf', 'codUf');
    //this.buscaDadosSelects("domMunicipio", "cidades", "nomeCidade", "idCidade");
    this.$validator.localize('ptBr', locale);
  },
  components: {
    'v-select': vSelect,
    'vs-number': Money,
  },
};
</script>
<!------------ END SCRIPT ------------>

<!------------ START STYLE ------------>
<style>
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type='number'] {
  -moz-appearance: textfield;
  appearance: textfield;
}
</style>
<!------------ END STYLE ------------>
